<template>
  <div>
    <linkook-live-banner></linkook-live-banner>
    <linkook-live-tiles></linkook-live-tiles>
  </div>
</template>
<script>
import LinkookLiveBanner from "@/components/layout/LinkookLiveBanner.vue";
import LinkookLiveTiles from "@/components/LiveList.vue";
import { useUserStore } from "@/store/user";

export default {
  name: "LinkookLiveView",
  components: {
    LinkookLiveBanner,
    LinkookLiveTiles,
  },
  data() {
    return {
      userStore: useUserStore(),
    };
  },
  async created() {
    // 로그인된 사용자의 닉네임 체크 및 업데이트
    await this.checkAndUpdateUserNickname();
  },
  methods: {
    async checkAndUpdateUserNickname() {
      try {
        // 로그인된 사용자인지 확인
        if (!this.userStore.isLogin || !this.userStore.email) {
          return;
        }

        // Firebase에서 사용자 정보 가져오기
        const { getUserInfo } = await import("@/utils/read/user");
        const userData = await getUserInfo(this.userStore.email);

        if (userData) {

          // Firebase의 닉네임과 현재 store의 닉네임이 다르면 업데이트
          if (
            userData.nickname &&
            userData.nickname !== this.userStore.nickname
          ) {
            this.userStore.setNickname(userData.nickname);
          }
        }
      } catch (error) {
        // 닉네임 체크 실패는 조용히 처리 (사용자 경험에 영향 없음)
        console.warn("사용자 닉네임 체크 실패:", error);
      }
    },
  },
};
</script>